import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DefaultLayoutComponent } from './containers';
import { Page404Component } from './views/pages/page404/page404.component';
import { Page500Component } from './views/pages/page500/page500.component';
import { LoginComponent } from './views/pages/login/login.component';
import { ForgotPasswordComponent } from './views/pages/forgot_password/forgot_password.component';
import { VerifyOtpPasswordComponent } from './views/pages/verify_otp_password/verify_otp_password.component';
import { RegisterComponent } from './views/pages/register/register.component';
import { AuthGuard } from './auth.guard';
import { CalendarComponent } from './views/calendar/calendar.component';
import { ForgotPasswordVerificationAuthGuard } from './guards/forgot-password-verification-auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'my_calendar',
    pathMatch: 'full'
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard-stats',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/dashboard-stats/dashboard-stats.module').then((m) => m.DashboardStatsModule)
      },
      {
        path: 'theme',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/theme/theme.module').then((m) => m.ThemeModule)
      },
      {
        path: 'base',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/base/base.module').then((m) => m.BaseModule)
      },
      {
        path: 'buttons',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/buttons/buttons.module').then((m) => m.ButtonsModule)
      },
      {
        path: 'forms',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/forms/forms.module').then((m) => m.CoreUIFormsModule)
      },
      {
        path: 'student_admin',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/student-admin/student-admin.module').then((m) => m.StudentAdminModule)
      },
      {
        path: 'staff_admin',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/staff-admin/staff-admin.module').then((m) => m.StaffAdminModule)
      },
      {
        path: 'events',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/events/events.module').then((m) => m.EventsModule)
      },
      {
        path: 'my_calendar',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/calendar/calendar.module').then((m) => m.CalendarsModule)
      },
      {
        path: 'room_schedule',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/room_scheduling/room-schedule.module').then((m) => m.RoomScheduleModule)
      },
      {
        path: 'exam',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/exam/exam.module').then((m) => m.ExamModule)
      },
      {
        path: 'security',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/security/security.module').then((m) => m.SecurityModule)
      },
      {
        path: 'student',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/student/student.module').then((m) => m.StudentModule)
      },
      {
        path: 'warden',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/warden/warden.module').then((m) => m.WardenModule)
      },
      {
        path: 'hostel',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/hostel/hostel.module').then((m) => m.HostelModule)
      },
      {
        path: 'charts',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/charts/charts.module').then((m) => m.ChartsModule)
      },
      {
        path: 'icons',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/icons/icons.module').then((m) => m.IconsModule)
      },
      {
        path: 'notifications',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/notifications/notifications.module').then((m) => m.NotificationsModule)
      },
      {
        path: 'widgets',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/widgets/widgets.module').then((m) => m.WidgetsModule)
      },
      {
        path: 'pages',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/pages/pages.module').then((m) => m.PagesModule)
      },
    ]
  },
  {
    path: '404',
    component: Page404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: Page500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'verify_otp_password',
    component: VerifyOtpPasswordComponent,
    canActivate: [ForgotPasswordVerificationAuthGuard],
    data: {
      title: 'Verify OTP & Set Password Page'
    }
  },
  {
    path: 'forgot_password',
    component: ForgotPasswordComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    }
  },
  {
    path: 'calendar',
    component: CalendarComponent,
    data: {
      title: 'Timetable Calendar'
    }
  },
  { path: '**', redirectTo: 'dashboard' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking'
      // relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
